import axiosapi from "./axiosAPI";

// Get All Vulnerabilities
export const getAllVulnerabilities = async (
    setVulnerabilities,
    setFetcherror
) => {
    
	try{
		const res =await axiosapi.get("/vulnerabilities");
        setVulnerabilities(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Vulnerabilities");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Vulnerabilities");
		}
		
	}
	
};



// Get One Vulnerability
export const getOneVulnerability = async (
    pkid,
    setFetcherror,  
    setVulnerability
    
)=>{
	try{
		const res =await axiosapi.get(`/vulnerabilities/${pkid}`);
        setVulnerability(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Vulnerability");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Vulnerability");
		}
		
	}
	
};


// Create New Vulnerability
export const createVulnerability = async (
    vulnerability,
    setVulnerability,
    setFetcherror,
    handleAllToasts,
    setVulnerabilities

) => {

    if (!vulnerability ) {
        handleAllToasts(2, "No Vulnerability Provided"); 
            return; 
        }

    const PushItem = {
            name: vulnerability,
        };

    try{
        await axiosapi.post("/vulnerabilities/",PushItem );
        setVulnerability("");
        handleAllToasts(1, "Vulnerability Created Successfully");
        getAllVulnerabilities(setVulnerabilities, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Vulnerability");
            handleAllToasts(2, "Could Not update The Vulnerability");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Vulnerability");
            handleAllToasts(2, "Could Not update The Vulnerability");
            
        }
        
    }
    
}


// Edit Existing Vulnerability

export const editVulnerability = async (
    vulnerabilitypkid,
    vulnerability,
    setVulnerability,
    setFetcherror,
    handleAllToasts,
    setVulnerabilities
              
        ) => {

            if (!vulnerability) {
                handleAllToasts(2, "No Vulnerability Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:vulnerabilitypkid,
                    name: vulnerability,
                };

            try{
                await axiosapi.patch("/vulnerabilities/",PushItem );
                setVulnerability("");
                handleAllToasts(1, "Vulnerability Updated Successfully");
                getAllVulnerabilities(setVulnerabilities, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Vulnerability");
                    handleAllToasts(2, "Could Not Update Vulnerability");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Vulnerability");
                    handleAllToasts(2, "Could Not Update Vulnerability");
                    
                }
                
            }
            
};



// Delete Existing Vulnerability.

export const deleteVulnerability = async (
    vulnerabilitypkid,
    setVulnerabilities,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/vulnerabilities/${vulnerabilitypkid}`);
        let finalData = res.data.message;
        getAllVulnerabilities(setVulnerabilities, setFetcherror);
        handleAllToasts(1, "Vulnerability Deleted Successfully");
        console.log("Deleted:", finalData);
        
        
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Vulnerability");
            handleAllToasts(2,"Error: Could Not Delete Vulnerability");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Vulnerability");
            handleAllToasts(2,"Error: Could Not Delete Vulnerability");
		}
		
	}
	
};